import React from 'react';
import { createPortal } from 'react-dom';
import './AgeWarningModal.css';

const AgeWarningModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  const modal = (
    <div className="age-warning-overlay" onClick={onClose}>
      <div className="age-warning-popup" onClick={(e) => e.stopPropagation()}>
        {/* Warning Message */}
        <div className="warning-content">
          <p className="warning-message">
            This movie is rated "A" and is only for viewers above 18. Please carry a valid ID/Age Proof to the theatre. If you are denied entry due to age or ID issues, you will not get a refund.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="warning-actions">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="confirm-btn" onClick={onConfirm}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default AgeWarningModal;

